import React from "react";
import { FormActions } from "../app";
import { ProjectFormFields } from "./ProjectFormSections";

export function ProjectForm({
  formData,
  setFormData,
  clients,
  t,
  onSubmit,
  onCancel,
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <ProjectFormFields
        formData={formData}
        setFormData={setFormData}
        clients={clients}
        t={t}
      />
      <FormActions
        cancelLabel={t("cancel")}
        submitLabel={t("save")}
        onCancel={onCancel}
        submitTestId="save-project-btn"
      />
    </form>
  );
}

export default ProjectForm;
